import * as React from "react";
import "./reconciliationModal.scss"
import {Icon} from "../../../../../hiberUiKit/src/atoms/Icon/Icon";
import IconWrapper from "../../../../../hiberUiKit/src/atoms/Icon/IconWrapper";

interface IProps {
	visible: boolean;
	navigateLeftDisabled: boolean;
	navigateRightDisabled: boolean;
	onNavigateLeft: () => void;
	onNavigateRight: () => void;
	navigationLabel: string;
}

export const ReconciliationModalNavigation: React.SFC<IProps> = (props) => {
	if (!props.visible) {
		return null;
	}
	return (
		<>
			<IconWrapper icon={Icon.ArrowLeft}
						 variant={"burgundy"}
						 disabled={props.navigateLeftDisabled}
						 disabledVariant={"gray"}
						 onClick={props.onNavigateLeft}/>
			<IconWrapper icon={Icon.ArrowRight}
						 variant={"burgundy"}
						 disabled={props.navigateRightDisabled}
						 disabledVariant={"gray"}
						 onClick={props.onNavigateRight}/>
			<div>{props.navigationLabel}</div>
		</>
	);
};
